import AuthGuard from '@components/AuthGuard';
import useProject from '@hooks/useProject';
import { Fragment } from 'react';

import LinkContainer from './LinkContainer';
import LinkRow from './LinkRow';

function OrderContents() {
  const project = useProject();
  return (<LinkContainer title='모아보기'>
      {project?.features?.orderEnabled && (
          <Fragment>
              <LinkRow label='오더' activityName='ShopListActivity'
                       activityParams={{ isOrder: true, type: 'LIST' }} />
              <AuthGuard>
                  <LinkRow label='주문 내역'
                           activityName='OrderLogsActivity'
                           activityParams={{ duration: 'WEEK' }} />
              </AuthGuard>
          </Fragment>
      )}
      {project?.features.giftEnabled && (
          <AuthGuard>
              <LinkRow label='선물하기' activityName='GiftsActivity'
                       activityParams={{ type: 'MAIN' }} />
          </AuthGuard>
      )}
      {project?.features.ppCardEnabled && (
          <AuthGuard>
              <LinkRow label='선불카드' activityName='MyPrepaidCardActivity'
                       activityParams={{}}/>
          </AuthGuard>
      )}
      {/*
      <AuthGuard>
          <LinkRow label='간편카드 관리' />
      </AuthGuard>
      */}
      {/*
      <AuthGuard>
          <LinkRow label='MY메뉴' activityName='MyMenuActivity'
                   activityParams={{}}/>
      </AuthGuard>
      */}
      <LinkRow label='매장찾기'
               activityName='ShopListActivity'
               activityParams={{ isOrder: false, type: 'LIST' }}/>
      {import.meta.env.MODE !== 'production' && (
          <LinkRow label='테스트 설정' activityName='ProjectActivity'
                   activityParams={{}}/>
      )}
    </LinkContainer>);
}

export default OrderContents;
